import {Component, OnInit} from '@angular/core';
import {CostPriceComponentService} from '../cost-price-component.service';
import {ApiResponse, BaseModalComponent, PRIVILEGES} from 'common-shared';
import {BehaviorSubject, Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {CostPriceComponentViewModel} from 'web-shared';

@Component({
  selector: 'mes-cost-price-component-edit-modal',
  templateUrl: './cost-price-component-edit-modal.component.html',
  styleUrls: ['./cost-price-component-edit-modal.component.scss']
})
export class CostPriceComponentEditModalComponent extends BaseModalComponent implements OnInit {

  entityId: string;
  code: string;
  cpc$: Observable<CostPriceComponentViewModel>;
  cpc: CostPriceComponentViewModel;
  response: ApiResponse<any>;
  isPristine$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  protected readonly PRIVILEGES = PRIVILEGES;

  constructor(public cpcService: CostPriceComponentService) {
    super();
  }

  ngOnInit() {
    this.cpc$ = (this.entityId
      ? this.cpcService.loadOne(this.entityId)
      : new Observable<CostPriceComponentViewModel>(subscriber => subscriber.next(CostPriceComponentViewModel.CreateDefault({Code: this.code}))))
      .pipe(tap(cpc => this.cpc = cpc))
  }

  onChanged(isPristine: boolean) {
    this.isPristine$.next(isPristine);
  }

  save(withClose: boolean = true) {
    this.cpcService.save(this.cpc).subscribe(value => {
      if (withClose) {
        this.close(value.Id)
      }
    }, value1 => this.response = value1.error);
  }

  delete() {
    this.cpcService.remove(this.cpc).subscribe(() => this.close(), value1 => this.response = value1.error);
  }

  add() {
    this.cpcService.addNew(this.cpc).subscribe(value => this.close(value.Id), value1 => this.response = value1.error);
  }
}
